import type { DiscountedLineItem } from '@/modules/cart/domain/CartLineItem';
import type { LineItem } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';

const calculateDiscountForPrice = (
  discountedPrice: DiscountedLineItem,
  quantity: number
) => {
  return discountedPrice?.discountedPrice?.includedDiscounts.reduce(
    (discountTotal, discount) => {
      const price = discount?.discountedAmount?.centAmount ?? 0;
      return discountTotal + quantity * price;
    },
    0
  );
};
const calculateDiscountForLineItem = (lineItem?: LineItem) => {
  return (
    lineItem?.discountedPricePerQuantity?.reduce(
      (lineTotal, discountedPrice) => {
        const quantity = discountedPrice?.quantity ?? 0;
        return lineTotal + calculateDiscountForPrice(discountedPrice, quantity);
      },
      0
    ) ?? 0
  );
};

const calculateCouponProductsDiscountsAmount = (
  lineItems?: LineItem[],
  hasCouponApplied?: boolean
) => {
  if (!hasCouponApplied) return 0;

  return (
    lineItems?.reduce((total, lineItem) => {
      return total + calculateDiscountForLineItem(lineItem);
    }, 0) ?? 0
  );
};

const calculateProductPriceWithDiscounts = (
  price: number,
  discounts: DiscountedLineItem[]
): number => {
  const totalDiscount = discounts.reduce(
    (acc, { discountedPrice }) =>
      acc +
      discountedPrice.includedDiscounts.reduce(
        (sum, { discountedAmount }) => sum + discountedAmount.centAmount,
        0
      ),
    0
  );

  return Math.max(0, price - totalDiscount);
};

const calculateDeliveriesDiscountsAmount = () => {};
const calculateOptionsDiscountsAmount = () => {};

export {
  calculateCouponProductsDiscountsAmount,
  calculateDeliveriesDiscountsAmount,
  calculateOptionsDiscountsAmount,
  calculateProductPriceWithDiscounts
};
